import React from "react";
import { useSelector } from "react-redux";
import { Settings as SettingsIcon } from "@mui/icons-material";
import { ListItemIcon, MenuItem } from "@mui/material";

import analytics from "fond/analytics";
import { getCurrentProject } from "fond/project/redux";
import ProjectSettings from "fond/projectSettings/ProjectSettings";
import { PermissionLevel, Store } from "fond/types";
import { Actions, permissionCheck } from "fond/utils/permissions";

import { trackPageMenuItemClick } from "../helper";

interface IProps {
  permissionLevel: PermissionLevel;
  handleClose: () => void;
}

const Settings: React.FC<IProps> = ({ permissionLevel, handleClose }: IProps) => {
  const [isProjectSettingsModalOpen, setProjectSettingsModalOpen] = React.useState(false);
  const canEdit = permissionCheck(permissionLevel, Actions.PROJECT_EDIT);
  const project = useSelector((state: Store) => getCurrentProject(state.project));

  /**
   * Handles opening the Project Settings modal
   */
  const handleClick = () => {
    if (canEdit) {
      setProjectSettingsModalOpen(true);
      analytics.track("Opened project settings modal", { projectId: project!.ID });
    }
    handleClose();
    trackPageMenuItemClick("project", "settings", project);
  };

  return (
    <>
      <MenuItem data-testid="settings-button" onClick={handleClick} disabled={!canEdit}>
        <ListItemIcon>
          <SettingsIcon />
        </ListItemIcon>
        Settings
      </MenuItem>
      <ProjectSettings isOpen={isProjectSettingsModalOpen} onClose={() => setProjectSettingsModalOpen(false)} />
    </>
  );
};

export default Settings;
